<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "trips.activity.train-ticket" | translate }}</h2>

<ng-container *ngIf="form">
  <mat-dialog-content [formGroup]="form" class="dialog-content">
    <div class="grid-container">
      <!-- Departure Station -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.train-ticket-departure-station" | translate
        }}</mat-label>
        <input matInput formControlName="departureStation" required />
        <mat-error
          *ngIf="
            form.get('departureStation')?.invalid &&
            form.get('departureStation')?.touched
          "
        >
          {{ getLabelErrorMessage('departureStation') | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Arrival Station -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.train-ticket-arrival-station" | translate
        }}</mat-label>
        <input matInput formControlName="arrivalStation" required />
        <mat-error
          *ngIf="
            form.get('arrivalStation')?.invalid &&
            form.get('arrivalStation')?.touched
          "
        >
          {{ getLabelErrorMessage('arrivalStation') | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Total Price -->
      <input-monetary-amount
        appCombinedReadonly
        #totalPriceReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
        formControlName="totalPrice"
        [required]="true"
        label="total-price"
      ></input-monetary-amount>

      <!-- Departure Time -->
      <input-time
        formControlName="startTime"
        [required]="true"
        label="departure-time"
      ></input-time>

      <!-- Arrival Time -->
      <input-time
        formControlName="endTime"
        [required]="true"
        label="arrival-time"
      ></input-time>


      <!-- Advance Purchase Days -->
      <mat-form-field appearance="outline">
        <mat-label>{{ "advance-purchase-days" | translate }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="advancePurchaseDays"
          [required]="true"
        />
        <mat-error
          *ngIf="
            form.get('advancePurchaseDays')?.invalid &&
            form.get('advancePurchaseDays')?.touched
          "
        >
          {{ "required-advance-purchase-days" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Train Number -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.train-ticket-train-number" | translate
        }}</mat-label>
        <input matInput formControlName="trainNumber" />
      </mat-form-field>

      <!-- Carriage -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.train-ticket-carriage" | translate
        }}</mat-label>
        <input matInput formControlName="carriage" />
      </mat-form-field>

      <!-- Seat Number -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.train-ticket-seat-number" | translate
        }}</mat-label>
        <input matInput formControlName="seatNumber" />
      </mat-form-field>

      <!-- Notes -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "notes" | translate }}</mat-label>
        <textarea matInput formControlName="notes" rows="3"></textarea>
      </mat-form-field>

      <!-- Disclaimer -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "disclaimer" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="disclaimer"
          rows="3"
          maxlength="500"
        ></textarea>
        <mat-hint
          >{{ form.get("disclaimer")?.value?.length || 0 }}/500</mat-hint
        >
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-content">
    <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!form.valid"
    >
      {{ "confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
